import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

export const DataTableStyled = styled(Box)(({ theme }) => ({
  overflow: "auto",
  height: "100%",

  ".table-container": {
    padding: "0 16px",
    borderRadius: "12px",
    overflow: "auto",
    boxShadow: "none",
    height: "calc(100% - 46px)",

    "& .MuiTable-root": {
      height: "100%",
    },

    "& .MuiTableHead-root .MuiTableRow-root": {
      width: "100%",
      tableLayout: "fixed",
    },

    "& .MuiTableBody-root .MuiTableRow-root": {
      width: "100%",
      tableLayout: "fixed",
    },

    "& .MuiTableBody-root": {
      overflow: "auto",
      height: "calc(100% - 54.5px)",
    },
  },

  ".table-header": {
    backgroundColor: theme.palette.background?.secondary || "#FFFFFF",
    fontWeight: 600,
    color: theme.palette.text?.primary || "#111827",
    fontSize: "14px",
    lineHeight: "20px",
    padding: "16px 13px 16px 13px",
    borderBottom: `1px solid ${theme.palette.border?.medium || "#E5E7EB"}`,
    "& p": {
      marginRight: "4px",
      fontWeight: 700,
      color: theme.palette.text?.secondary,
    },
  },

  ".table-row": {
    "&:hover": {
      backgroundColor: theme.palette.action?.hover || "rgba(0, 0, 0, 0.04)",
    },
    "&:last-child": {
      "& .table-cell": {
        borderBottom: "none",
      },
    },
    "&:not(:last-child)": {
      borderBottom: `1px solid ${theme.palette.border?.light || "#F3F4F6"}`,
    },
  },

  ".table-cell": {
    padding: "12px 0 12px 12px",
    fontSize: "14px",
    fontFamily: "Nunito",
    lineHeight: "20px",
    color: theme.palette.text?.primary || "#111827",
    paddingRight: "13px",
    fontWeight: 400,

    "& a, & .clickable, & [data-clickable='true']": {
      fontFamily: "Nunito",
      fontSize: "14px",
      fontWeight: 700,
      color: "#0E426D",
      textDecoration: "underline",
      cursor: "pointer",
    },
  },

  ".no-data-cell": {
    padding: "32px 16px",
  },

  ".no-data-text": {
    color: theme.palette.text?.secondary || "#6B7280",
    fontSize: "16px",
    lineHeight: "24px",
  },

  ".pagination-section": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "16px",
    flexShrink: 0,
    height: "30px",
  },

  ".pagination-info": {
    color: theme.palette.text?.secondary || "#6B7280",
    fontSize: "14px",
    lineHeight: "20px",
  },

  ".pagination": {
    "& .MuiPaginationItem-root": {
      backgroundColor: theme.palette.background?.pagination || "#FAFBFD",
      border: `0.6px solid ${theme.palette.border?.pagination || "#E2E8F0"}`,
      borderRadius: "8px",
      color: theme.palette.text?.primary || "#111827",
      minWidth: "43px",
      height: "30px",
      margin: "0 2px",

      "&[aria-label*='previous']": {
        marginRight: "0",
        borderTopRightRadius: "0",
        borderBottomRightRadius: "0",
        borderRight: `0.6px solid ${
          theme.palette.border?.pagination || "#E2E8F0"
        }`,
      },

      "&[aria-label*='next']": {
        marginLeft: "0",
        borderTopLeftRadius: "0",
        borderBottomLeftRadius: "0",
        borderLeft: "none",
      },

      "&[tabindex='0']": {
        opacity: 1,
        cursor: "pointer",
      },

      "&.Mui-disabled": {
        opacity: 1,
        "&[tabindex='-1']": {
          "& svg": {
            opacity: 0.4,
          },
          cursor: "not-allowed",
        },
      },
    },
  },
}));
